// DEF-Q09 (2026-10-31): the "Est. total at order" on the quote wizard, in the
// server's own order of operations. CreateSalesQuoteHandler asks Avalara for the
// tax (Step D) BEFORE it posts the negative STID "Trade In Discount" charge
// (Step K2), and the plan snapshot total is QuoteAmt + TotalMiscAmt (which carries
// the STID credit) + TotalTax. So the estimate is: pre-tax price, minus the
// trade-in credit, plus the tax estimate (worked out, like the server's, on the
// price before the trade-in). Before this the trade-in was never taken off.
//
// Example: $10,000 price, $1,000 trade-in, $725 est. tax -> $9,725 (was $10,725).
export function estTotalAtOrder(preTaxTotal, tradeInCredit, taxAmount) {
  return (Number(preTaxTotal) || 0) - (Number(tradeInCredit) || 0) + (Number(taxAmount) || 0);
}
